// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ad-p","productName":"Table_productName__28Jkj"};